import React from 'react';
import styled from 'styled-components';
import { NormalContainer } from '../../global-styles'

export default function Footer() {
    return (
        <React.Fragment>
            <FooterContainer>
                <Container>
                    <Text>Eat. Build. Rest. Repeat | Made with ❤️ By Vinayak Singh</Text>
                </Container>
            </FooterContainer>
        </React.Fragment>
    )
}


const FooterContainer = styled.div`
    background-color: #000;
    display: flex;
    color: #EAEAEA;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height:80px;
    border-top: 1px solid #474747;
`;

const Text = styled.p`
    font-size: 1rem;
    text-align: center;
`;

const Container = styled(NormalContainer)``;